import { render, staticRenderFns } from "./app-update.vue?vue&type=template&id=3310692a&scoped=true&"
import script from "./app-update.vue?vue&type=script&lang=js&"
export * from "./app-update.vue?vue&type=script&lang=js&"
import style0 from "./app-update.vue?vue&type=style&index=0&id=3310692a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3310692a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3310692a')) {
      api.createRecord('3310692a', component.options)
    } else {
      api.reload('3310692a', component.options)
    }
    module.hot.accept("./app-update.vue?vue&type=template&id=3310692a&scoped=true&", function () {
      api.rerender('3310692a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/app-update.vue"
export default component.exports